// extracted by mini-css-extract-plugin
module.exports = {"piechart":"styles_piechart__2qznl","noData":"styles_noData__39Cp9"};